
import React from 'react';
import { UserPlus, MessageSquare, CheckCircle } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      step: 1,
      title: "Crea tu cuenta",
      icon: UserPlus,
    },
    {
      step: 2,
      title: "Haz tu pregunta migratoria",
      icon: MessageSquare,
    },
    {
      step: 3,
      title: "Recibe orientación clara",
      icon: CheckCircle,
    }
  ];

  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6 bg-blue-50">
      <div className="max-w-6xl mx-auto">
        <h2 
          className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-12"
          style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          Pasos a seguir
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="text-center">
                <div className="flex flex-col items-center mb-6">
                  <div className="w-20 h-20 bg-[#2563EB] rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="h-10 w-10 text-white" />
                  </div>
                  <div className="w-8 h-8 bg-[#2563EB] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">{step.step}</span>
                  </div>
                </div>
                
                <h3 
                  className="text-lg sm:text-xl font-semibold text-gray-900"
                  style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
                >
                  {step.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
